module.exports = __webpack_public_path__ + "static/media/2.5e0e5057.jpeg";